var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272E35",
    fillRule: "evenodd",
    d: "M1.3 3A2.2 2.2 0 0 1 3.5.8h10A2.2 2.2 0 0 1 15.7 3v7.6a2.2 2.2 0 0 1-2.2 2.2h-2.4a1 1 0 0 0-.8.4l-1.32 1.76a.6.6 0 0 1-.96 0L6.7 13.2a1 1 0 0 0-.8-.4H3.5a2.2 2.2 0 0 1-2.2-2.2zm2.2-1a1 1 0 0 0-1 1v7.6a1 1 0 0 0 1 1h2.4a2.2 2.2 0 0 1 1.76.88l.84 1.12.84-1.12a2.2 2.2 0 0 1 1.76-.88h2.4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgComment;